// ---------------------------------------------------------------------------
// Academic Timeline
// ---------------------------------------------------------------------------
// Vertical timeline entries shown above the contact section.
// Each entry has a year/range, title, subtitle, and optional description.
// Set active: true on your current position.
// logo: import an image for the card. link: URL for the institution.

import northwesternLogo from '../assets/profile/northwestern.png';
import marineCodersLogo from '../assets/profile/marine-coders.png';
import usmcLogo from '../assets/profile/usmc.png';
import usnaLogo from '../assets/profile/usna.jpg';

const timeline = [
  {
    year: '2025 - Present',
    title: 'Ph.D. Electrical & Computer Engineering',
    subtitle: 'Northwestern University',
    description: 'Embodied Systems Lab — power-constrained computing, hyperspectral sensing, semiconductor fabrication',
    logo: northwesternLogo,
    link: 'https://www.mccormick.northwestern.edu/electrical-computer/',
    active: true,
  },
  {
    year: '2023 - 2025',
    title: 'M.S. Electrical & Computer Engineering',
    subtitle: 'Northwestern University',
    description: 'Best Thesis Award, ECE Annual Awards 2025',
    logo: northwesternLogo,
    link: 'https://www.mccormick.northwestern.edu/electrical-computer/news-events/news/articles/2025/2025-ece-annual-award-winners.html',
  },
  {
    year: '2023 - 2025',
    title: 'Marine Coder',
    subtitle: 'U.S. Marine Corps Reserve',
    description: '',
    logo: marineCodersLogo,
    link: 'https://marines.dev/',
  },
  {
    year: '2018 - 2023',
    title: 'Communications Officer',
    subtitle: 'U.S. Marine Corps, Active Duty',
    description: '',
    logo: usmcLogo,
  },
  {
    year: '2015 - 2018',
    title: 'B.S. Electrical Engineering',
    subtitle: 'United States Naval Academy',
    description: '',
    logo: usnaLogo,
    link: 'https://www.usna.edu/WRC/index.php',
  },
];

export default timeline;
